import secureApi from "../services/secureApi";
// GET CLINIC LIST
export const getClinicListApi = async (userId) => {
  try {
    if (!userId) {
      return [];
    }
    const response = await secureApi.post(
      "/clinics/admin/list",
      {
        userid: String(userId),
      }
    );
    return response.data;
  } catch (error) {
    return [];
  }
};
// GET CLINIC SUMMARY
export const getClinicSummaryApi = async (userId) => {
  try {
    if (!userId) {
      return [];
    }
    const response = await secureApi.get(
      `/users/admin/ClinicsSummary/${userId}`,
    );
    return response.data;
  } catch (error) {
    return [];
  }
};